@if (canRequestValidation) {
  <button
    *appHasRole="rolesAllowedToRequestValidation"
    mat-icon-button
    [matMenuTriggerFor]="userMenu.menu"
    [matTooltip]="'Demander la validation ' + (validationType() | validationRequestTypeLabel)"
  >
    <mat-icon class="warning">playlist_add_check</mat-icon>
  </button>
  <app-user-menu
    #userMenu
    [roles]="requestToRoles"
    (userSelected)="requestValidation($event)"
  ></app-user-menu>
}
